export default __webpack_public_path__ + "static/media/au.dd1760ce.svg";